"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageFn = {
    setStorage: function (key, value) {
        if (this.getStorageType(value) === "Object" || this.getStorageType(value) === "Array") { // 如果是对象
            value = JSON.stringify(value);
        }
        window.localStorage.setItem(key, value);
    },
    getStorage: function (key) {
        var value = window.localStorage.getItem(key);
        if (value === null) { // 如果不存在
            return false;
        }
        if (value && value.substring(0, 1) === "{" || value.substring(0, 1) === "[") { // 如果字符串符合对象或者数组基本特征
            value = JSON.parse(value); // 把字符串转为对象
        }
        return value;
    },
    removeStorage: function (key) {
        this.getStorage(key) && window.localStorage.removeItem(key);
    },
    clearStorage: function () {
        window.localStorage.clear(); // 清空本地存储
    },
    getStorageType: function (object) {
        /**
         * 方法来源：prototype.js
         * getStorage(5); // => "Number"
         * getStorage({}); // => "Object"
         * getStorage(/foo/); // => "RegExp"
         * getStorage(''); // => "String"
         * getStorage(true); // => "Boolean"
         * getStorage([]); // => "Array"
         * getStorage(undefined); // => "Window"
         * getStorage(Element); // => "Constructor"
         **/
        return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1];
    }
};
exports.default = exports.LocalStorageFn;
//# sourceMappingURL=LocalStorage.js.map